import React from "react"
import { useSelector } from "react-redux"

import CMSTypography from "../typography/CMSTypography"

const ServiceRequestConstants = () => {
  const currentProjectID = useSelector((state) => state.settings.currentProject)

  const cloudInfra = [
    {
      key: {
        text: "General Infrastructure Service",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=c53e2248dbd64810347b41a405961930&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText:
          "Please use this type of request if your request does not follow under any other category listed."
      },
      value: [
        {
          text: "General Infrastructure Change Request",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=9255155d6f8ad20073ccf13f5d3ee4f8",
          hoverText:
            "General Infrastructure Request (To be only used if request you are making is not listed)"
        },
        {
          text: "Manage File Copy Action",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=2cf667061b192950890c1179b04bcbff",
          hoverText:
            "This Catalog can be used to copy entire data of folder A (source bucket) to folder B (destination bucket). Buckets can be present in the same account or different accounts."
        },
        {
          text: "Cloud Resource Tagging",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=ede908a11b55a510b76ffd9f034bcb09",
          hoverText:
            "Use this item to raise Resource Tagging Request for all Cloud Service Providers "
        },
        {
          text: "BIAS Request",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=f924f9f1dbbf1190b581273a13961986",
          hoverText:
            "Use this catalog item to open general service request related to cloud infrastructure"
        },
        {
          text: "General Infrastructure Enhancement Request",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=e6082107db04a814052ddda5ca961976",
          hoverText:
            "Use this catalog item to open general ServiceEnhancement request related to cloud infrastructure and Application"
        }
      ]
    },
    {
      key: {
        text: "Manage servers",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=554913401b78889097bc628a2d4bcb59&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText:
          "Use this category to request services related to servers within environment such as add/modify/restart/decommission a server."
      },
      value: [
        {
          text: "Change Request – Add Servers",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=2cf49bf96f86160073ccf13f5d3ee49a",
          hoverText: "New Server(s) Request"
        },
        {
          text: "Change Request – Modify Servers",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=7a97e7716fc6160073ccf13f5d3ee4a3",
          hoverText: "Modify Server Resources"
        },
        {
          text: "Change Request – Power off/Restart/ Decommission Server ",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=5535e6466f0e160073ccf13f5d3ee4d5",
          hoverText: "Request to power off, restart or decommission servers."
        }
        // {
        //   text: "Reboot Server",
        //   // link: "https://deloittecloud.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D1cb6dc3f1b152510b76ffd9f034bcbb2%26sysparm_link_parent%3D554913401b78889097bc628a2d4bcb59%26sysparm_catalog%3Dfc79fc8bdb608890347b41a4059619e7%26sysparm_catalog_view%3Dcatalog_cms_operations_catalog_%26sysparm_view%3Dcatalogs_default"
        //   link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=1cb6dc3f1b152510b76ffd9f034bcbb2"
        // }
      ]
    },
    {
      key: {
        text: "Manage Environment",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=ad195b841b38889097bc628a2d4bcb03&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText:
          "This category contains catalog items to perform activity to manage environments with OpenCloud."
      },
      value: [
        {
          text: "Environment Build Intake Form",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=20dc17eb1b80da5058a953d7624bcb10",
          hoverText: "New Environment Build Request"
        },
        {
          text: "Change Request – Backup / Restore",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=1301bba14f12d2001ddd3285f110c7f8",
          hoverText: "Change request to initate a backup or restore"
        },
        {
          text: "Change Request – Monitoring",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=0ca8a65a6fda920073ccf13f5d3ee410",
          hoverText: "Monitoring Request"
        },
        {
          text: "Change Request – Disaster Recovery",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=c610ebe54fde92001ddd3285f110c75b",
          hoverText: "Change request to add disaster recovery services"
        },
        {
          text: "Change Request – New Environment Build",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=a0c5ea6b4f16d6001ddd3285f110c787&sysparm_category=ad195b841b38889097bc628a2d4bcb03",
          hoverText: "Environment Build Change Request"
        },
        // {
        //   text: "Adhoc AMI Backup Request",
        //   link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=5a6e29f4dba3c5900cf5cae3b9961989",
        //   hoverText:
        //     "Please use this form to take the Adhoc AMI backup for AWS/GCP/AZURE"
        // },
        // {
        //   text: "SAP HANA Build",
        //   link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=d19d7a6a1b68a514b76ffd9f034bcb69",
        //   hoverText: "SAP HANA Build"
        // },
        ...(currentProjectID === "PROJ0036524"
          ? [
              {
                text: "New Account Provisioning",
                link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=1d6ca953db462c943cdde415ca961917"
              }
            ]
          : [])
      ]
    }
  ]

  const cloudEconomics = [
    {
      key: {
        text: "Chargeback",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=c65d1a8ddb3ad410052ddda5ca96194a&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1"
      },
      value: [
        {
          text: "One-Time Chargeback adjustment",
          hoverText: "Cloud User Chargeback – One-Time Chargeback adjustment"
        },
        {
          text: "Promo Credit",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=a7493599db1a9014052ddda5ca96190f",
          hoverText: "Please attach Credit Promotion information file"
        },
        {
          text: "Update WBS Code",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=3a88c699db9a9014052ddda5ca961914&",
          hoverText: "Cloud User Chargeback – Update WBS Code"
        }
      ]
    }
  ]

  const networkServices = [
    {
      key: {
        text: "Manage Network",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=8195134cdb58c0d0347b41a405961907&catalog_id=-1&spa=1",
        hoverText:
          "This includes catalog items for day to day operation changes related to firewall rules, Route table to enable network access."
      },
      value: [
        {
          text: "Firewall",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=24b10bd5dbd00cd0347b41a405961936",
          hoverText: "Use this item to open policy in firewall rule"
        },
        {
          text: "Load Balancer",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=a30eba9b1b7c041097bc628a2d4bcb8f",
          hoverText: "It is used to create/ deploy the Load balancer"
        },
        {
          text: "Network ACL (NACL) Modifications",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=791f0dd51be8845097bc628a2d4bcbd5",
          hoverText: "It is used to modify the network ACL"
        },
        // {
        //   text: "Network Device Deployment",
        //   link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=39b1fa571b3c041097bc628a2d4bcbf",
        //   hoverText: "To Deploy the Network Appliance"
        // },
        {
          text: "Routing",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=2ef66b56db308414347b41a405961985",
          hoverText: "To establish network connectivity"
        },
        {
          text: "Subnet Deployment",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=4ad55357db744410347b41a405961999",
          hoverText: "It is used for the creation of subnet"
        },
        // {
        //   text: "DNS",
        //   link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=d8b842794f56d2001ddd3285f110c7a3"
        // },
        // {
        //   text: "SMTP Relay",
        //   link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=7af56e1a6fda920073ccf13f5d3ee41d",
        //   hoverText:
        //     "This is for outbound SMTP relay servers only. Incoming POP and mailbox hosting is not supported by Deloitte Cloud Operations."
        // },
        {
          text: "VPC",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=819a0b5fdbf04410347b41a4059619a4",
          hoverText: "VPC Creation/ modification/deletion"
        }
      ]
    },
    {
      key: {
        text: "Network Connectivity",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=7ca5578cdb58c0d0347b41a405961935&catalog_id=-1&spa=1",
        hoverText:
          "This includes catalog items for Network connectivity establishment using VPN, Direct connect, etc."
      },
      value: [
        {
          text: "Direct Connect / Hybrid Connection",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=6a777a88db94c0d0347b41a4059619d6",
          hoverText: "Use this form to establish direct connect link."
        },
        {
          text: "NAT Gateway",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=2d676b5bdbf44410347b41a40596190f",
          hoverText:
            "It is used to enable outbound internet traffic from private subnet"
        },
        {
          text: "Network Peering",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=024127dfdbb44410347b41a40596196a",
          hoverText:
            "It is used to establish communication between two VPC using VPC Peering"
        },
        {
          text: "Security Group",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=e1cf2e931b3c041097bc628a2d4bcbdd",
          hoverText: "It is used to Permit traffic flow using security group"
        },
        {
          text: "VPN",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=0f930066db388414347b41a405961914",
          hoverText: "VPN Connectivity Request"
        }
      ]
    },
    {
      key: {
        text: "Market Place",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=dcc5d78cdb58c0d0347b41a405961934&catalog_id=-1&spa=1",
        hoverText:
          "This includes catalog items for new Appliance deployments from Market place."
      },
      value: [
        {
          text: "Palo Alto Deployment",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=bbc05f84db58c0d0347b41a405961971",
          hoverText: "It is used to deployment of Palo alto firewall"
        }
      ]
    }
  ]

  const security = [
    {
      key: {
        text: "Client Cyber Requests",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=ea479ef3db7038543cdde415ca9619f9&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText:
          "This category contains catalog items related to Client Cyber Requests"
      },
      value: [
        {
          text: "Client Cyber Support",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=4ed2699ddbb0f4d017b841db139619b9",
          hoverText: "Client Cyber Support"
        }
      ]
    },
    {
      key: {
        text: "Key/Certificate Management",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=34e18248db85c810347b41a405961961&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText:
          "This category contains catalog items related to security key or certificate management."
      },
      value: [
        {
          text: "Key Management",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=d4bbee7e1be8009097bc628a2d4bcb04",
          hoverText: "Create/modify(rotate)/delete access keys for IAM accounts"
        }
      ]
    },
    {
      key: {
        text: "Security Exception",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=30785dd91b0b9910890c1179b04bcb3f&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText:
          "This category contains catalog items related to Vulnerability Security Exemption Request and Security Tools Agent Exception Request"
      },
      value: [
        {
          text: "Security Tools Agent Exception Request ",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=5471bf35dbd2c9500cf5cae3b996197c",
          hoverText:
            "Please use this form to raise security tool/agent exception requests."
        },
        {
          text: "Vulnerability Security Exemption Request ",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=0b8428b4db6ab81017b841db139619c7",
          hoverText:
            "This information will be integrated with Qlik via API to take ServiceNow exemption requests into account in automated vulnerability reports."
        }
      ]
    },
    {
      key: {
        text: "Security Tools",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=ba1282c4db85c810347b41a40596190f&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText:
          "This Category contains catalog items to manage or request exception for security tools."
      },
      value: [
        {
          text: "Security Monitoring Exception",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=df8cf2ccdbb080d0347b41a40596194e",
          hoverText: "Exception Request for the security tools"
        },
        {
          text: "Security Tool Access Request",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=2c5455074fee57001ddd3285f110c712",
          hoverText: "Create/Modify access for security tools"
        }
      ]
    },
    {
      key: {
        text: "Vulnerability Management",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=ab52c248db85c810347b41a4059619d3&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText:
          "This category contains catalog items related to vulnerability management such as reporting vulnerability or report access."
      },
      value: [
        {
          text: "Vulnerability Management Adhoc Report Access",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=64faeecddbb488d0347b41a405961910",
          hoverText: "Adhoc vulnerability reports by POD Request"
        },
        {
          text: "Vulnerability Management Scheduled Report",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=fc237e41db3888d0347b41a4059619e1",
          hoverText: "Scan Vulnerability Management reports on weekly basis"
        }
      ]
    },
    {
      key: {
        text: "Risk Management",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=d0b233331be0489097bc628a2d4bcb7e&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText:
          "This category contains catalog items related to risk management such as to request logging, risk review, monitoring rule review etc."
      },
      value: [
        {
          text: "Logging Item",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=2acb938cdb7880d0347b41a4059619f7",
          hoverText: "Request log view access for AWS/Azure/GCP services"
        },
        {
          text: "Monitoring Rules Review",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=099697d91b54fb4097bc628a2d4bcb8a",
          hoverText: "Review Monitoring rules"
        },
        {
          text: "PEN Testing",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=f2277d7f1b6cc49097bc628a2d4bcb1d",
          hoverText: "Use this item to request PEN Testing."
        },
        {
          text: "Security Access Certification",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=a907d73b4fe513001ddd3285f110c75e",
          hoverText: "Security Access Certification Request"
        },
        {
          text: "Security Risk Review",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=ead57284dbb080d0347b41a40596191c",
          hoverText: "Review Security relevant risk"
        }
      ]
    },
    {
      key: {
        text: "Identity & Access Management",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=45c27fff1ba0489097bc628a2d4bcbcf&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText:
          "This category contains catalog items related to Identity & Access Management related activities such as IAM User/Role/Permission Management."
      },
      value: [
        {
          text: "AWS Cognito User Management",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=e23c9aaf1b41ad50890c1179b04bcb12",
          hoverText:
            "Please use this catalog to add/ modify/ delete and generate report for Users for a specific Cognito User Pool"
        },
        {
          text: "AWS Managed Active Directory User Management",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=5025f28a1b91ad10b76ffd9f034bcb75",
          hoverText:
            "The AWS Managed Active Directory User Management Catalog is used to Reset Password for External Users on AWS Managed Microsoft Active Directory. "
        },
        {
          text: "IAM Policy Management",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=690b1598dbfcc0d0347b41a4059619be",
          hoverText: "Request IAM Policy Management"
        },
        {
          text: "IAM Role Management",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=6c0d18c8db7040d0347b41a405961944",
          hoverText: "IAM Role Management"
        },
        {
          text: "IAM Service Account",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=78204019dbb0c8d0347b41a4059619d4",
          hoverText: "Create/Modify/Delete IAM Service Account"
        },
        {
          text: "IAM User Account Access",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=bdb5e7d7dbf44410347b41a4059619be",
          hoverText: "create/modify/delete IAM user access for AWS/Azure/GCP"
        },
        {
          text: "Root Activity Request",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=e0c094081b03370097bc628a2d4bcbea",
          hoverText: "Root Activity Request"
        },
        {
          text: "VM User Offboarding",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=015676dd1b68f5d4890c1179b04bcbb9",
          hoverText: "To offboard VM users"
        }
      ]
    }
  ]

  const businessOpServices = [
    {
      key: {
        text: "License Request",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=794de273db2a9c50052ddda5ca9619a2&catalog_id=-1&spa=1",
        hoverText: "Use this category to request license certificate management"
      },
      value: [
        {
          text: "Domain Certificate Request",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=f9ed62f7db2a9c50052ddda5ca96199f",
          hoverText: (
            <span>
              GoDaddy is a platform that provides many services ranging from
              domains to hosting.
              <br />
              <br />
              What we do? The Business Operations team will purchase ssl
              certificates and domains for CMS team members/client projects.
              <br />
              <br />
              Please visit{" "}
              <CMSTypography clickable href="https://www.godaddy.com/">
                https://www.godaddy.com/
              </CMSTypography>{" "}
              for pricing info.
              <br />
              <br />
              The Business Operations team will schedule a 15 minute meeting
              with the requestor and the person that will receive the
              certificate within 2 Business Days. Please make sure you are
              available.
            </span>
          )
        },
        {
          text: "Open VPN License Request",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=2651041cdbb29090052ddda5ca961935",
          hoverText: (
            <p>
              OpenVPN is open-source commercial software that implements virtual
              private network techniques to create secure point-to-point or
              site-to-site connections in routed or bridged configurations and
              remote access facilities.
              <br />
              <br />
              What we do? The Business Operations team will purchase license
              keys for CMS team members/client projects.
              <br />
              <br />
              Pricing Info below
              <br />
              Minimum purchase is 10 devices for 1 year for $180 (USD)
              <br />
              1 Year ($18.00 Per Device)
              <br />
              2 Years ($17.10 Per Device) 5% Discount
              <br />
              3 Years ($16.20 Per Device) 10% Discount
              <br />
              4 Years ($15.30 Per Device) 15% Discount
              <br />5 Years ($14.40 Per Device) 20% Discount
            </p>
          )
        }
      ]
    },
    {
      key: {
        text: "On-boarding/Off-boarding/Transitioning",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=a3d97eb1dbb8b8d03cdde415ca961971&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText: "CMS User On-boarding/Off-boarding"
      },
      value: [
        {
          text: "HCMS User Transition Catalog",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=0c111cd21b636190890c1179b04bcb72",
          hoverText: "HCMS Transition Catalog"
        },
        {
          text: "HCMS User On-boarding Catalog",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=389e7c561b2b2190b76ffd9f034bcb89",
          hoverText: "HCMS User On-boarding Catalog"
        }
      ]
    }
  ]

  const oktaUsrAccessMgmt = [
    {
      key: {
        text: "Okta User Access",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=51944dbc1bc2dc5097bc628a2d4bcb00&catalog_id=-1&spa=1"
      },
      value: [
        {
          text: "Creation of ASA Project",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=935a2ba2db0215d03cdde415ca9619ea",
          hoverText: "Creation of ASA Project"
        },
        {
          text: "Creation of Okta Group & Assigning to Okta applications",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=ee106e9edb42dd903cdde415ca961976",
          hoverText: "Creation of Okta Group & Assigning to Okta application"
        },
        {
          text: "Okta ASA Project Permission",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=0bd56f45db97d090052ddda5ca96197d",
          hoverText: "Okta ASA Project Permission"
        },
        {
          text: "Okta ASA Server Reassign / Removal",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=3497b578db59ddd40cf5cae3b9961933",
          hoverText: "Okta ASA Server Reassign / Removal"
        },
        {
          text: "Okta MFA Security Reset",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=c9c563bddbab9054052ddda5ca9619fb",
          hoverText: "Okta MFA Security Reset"
        },
        {
          text: "Okta Password Reset",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=4fb28d0cdbf060143cdde415ca961961",
          hoverText: "Okta Password Reset"
        },
        {
          text: "Okta User Group Access Removal",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=eb5ab868dbbf5c10052ddda5ca961943",
          hoverText: (
            <p>
              Please use this catalog item to remove multiple users from
              multiple Okta groups.
              <br />
              <br />
              If you would like to remove CMS user access completely (Okta &
              ServiceNow) from all projects and groups, then please use
              Off-boarding catalog item here
            </p>
          )
        },
        {
          text: "Okta User Group Management",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=0dd7caaadb0b18103cdde415ca961932",
          hoverText: "For More Information, Please refer KB0011428"
        },
        {
          text: "Okta User Resend Activation Email",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=92de9cabdb8bec10052ddda5ca96190a",
          hoverText: "Resend Okta activation email"
        }
      ]
    }
  ]

  const awsServices = [
    {
      key: {
        text: "AWS Support",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=9a0fb3854f9a53401ddd3285f110c78f&catalog_id=-1&spa=1"
      },
      value: [
        {
          text: "Create AWS Support case",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=98ceff454f9a53401ddd3285f110c718",
          hoverText: "Create an AWS Support Case"
        },
        {
          text: "DCO Open AWS Support case",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=939dca8137a6130065dedaa543990e98",
          hoverText: "Open an existing AWS Case"
        }
      ]
    }
  ]

  const aiMLServices = [
    {
      key: {
        text: "AI / ML Service",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=495dece01bfec6d058a953d7624bcb6d&catalog_id=-1&spa=1"
      },
      value: [
        {
          text: "AI / ML Service Request",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=8a1e446c1b3ac6d058a953d7624bcb0f",
          hoverText: "AI / ML Service Request"
        }
      ]
    }
  ]

  const globalCloudOpServices = [
    {
      key: {
        text: "Global Cloud Operations Services",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=c72d818fdbe08890347b41a4059619a9&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText:
          "Global Cloud Operations Services includes all services or requests handled by Global Cloud operations Team such as Service Management report or dashboard creation or access."
      },
      value: [
        {
          text: "Global Cloud Operations Request Management",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=2c93122f4fd123801ddd3285f110c717",
          hoverText: "Global Cloud Operations Request Management"
        },
        {
          text: "On/Off board GCO Member",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=66d45da6db80e0503cdde415ca9619e6",
          hoverText: "On-Offboarding Users"
        }
      ]
    }
  ]

  const hcmsOpsMgmt = [
    {
      key: {
        text: "HCMS Operations Management",
        link: "https://deloittecloud.service-now.com/Portal?id=sc_category&sys_id=bcb8c40fdb6b4a50cecf676ed3961937&catalog_id=fc79fc8bdb608890347b41a4059619e7&spa=1",
        hoverText:
          "Request Services from Operations Management Team (POD related Ops Issues, ServiceNow support)"
      },
      value: [
        {
          text: "Ops Management Catalog Item",
          link: "https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=19d988c3dbab4a50cecf676ed3961984",
          hoverText:
            "Use this catalog item to raise Service Request related to Ops issue, and other ServiceNow Support"
        }
      ]
    }
  ]

  return {
    cloudInfra,
    cloudEconomics,
    networkServices,
    security,
    businessOpServices,
    oktaUsrAccessMgmt,
    awsServices,
    aiMLServices,
    globalCloudOpServices,
    hcmsOpsMgmt
  }
}

export default ServiceRequestConstants
